import { Skeleton, Stack, Typography, styled } from "@mui/material"
import { type PropsWithChildren, type ReactNode, isValidElement } from "react"
import { AsideSectionAreas } from "../../../layout"

export type AsideSectionContentTitleProps = {
  title: ReactNode
} & ContentTitleProps &
  PropsWithChildren

export const AsideSectionContentTitle = ({
  title,
  fontSize,
  children,
}: AsideSectionContentTitleProps) => (
  <Stack
    direction="row"
    justifyContent="space-between"
    alignItems="center"
    gap={2}
    flexWrap="wrap"
    gridArea={AsideSectionAreas.contentHeader}
  >
    {isValidElement(title) ? (
      title
    ) : (
      <ContentTitle fontSize={fontSize}>{title}</ContentTitle>
    )}
    {children}
  </Stack>
)

export const AsideSectionContentTitleSkeleton = styled(Skeleton)(({ theme }) => ({
  height: theme.typography.pxToRem(18),
  marginBottom: theme.spacing(2.5),
  gridArea: AsideSectionAreas.contentHeader,
}))

export interface ContentTitleProps {
  fontSize?: number
}
export const ContentTitle = styled(Typography, {
  shouldForwardProp: (prop) => !(prop === "fontSize"),
})<ContentTitleProps>(({ theme, fontSize }) => ({
  color: theme.palette.primary.dark1,
  lineHeight: theme.typography.pxToRem(fontSize ? +fontSize + 2 : 20),
  fontSize: theme.typography.pxToRem(fontSize ? +fontSize : 18),
  fontWeight: 600,
  textTransform: "uppercase",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  minHeight: theme.typography.pxToRem(fontSize ? +fontSize + 2 : 20),
}))
